module.exports = "/images/side-reports.svg?80421b4bab988fb5d5edb515109233a3";